export const passwordRecoveryTokenStatuses = {
  unsubmitted: 'unsubmitted',
  requesting: 'requesting',
  completed: 'completed',
  error: 'error'
};
